import { Component, OnInit, Input, Pipe, Inject, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { Location } from '@angular/common';
import { StoreFilterComponent } from './store-filter/store-filter.component';
import PouchDB from 'pouchdb';
import PouchdbFind from 'pouchdb-find';
import { StorePouchDb } from './store.pouchdb.service';
import { ShelfValues, bookCategoeyEnums, bookCategories } from '../shared/models/shelfEnums';
import { CountrydetailsComponent } from './popups/countrydetails/countrydetails.component';
import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';
import { ViewChild, ElementRef, HostListener } from '@angular/core';
import { Constants } from '../shared/models/constants';
import { ArraySortPipe } from './sequenceByOrder';
import { StoreBookDetailsComponent } from './popups/storeBookDetails/storeBookDetails.component'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ShelfPouchDb } from '../shelf/shelf.pouchdb.service';
import * as _ from 'lodash';
import { IS_ElectronService } from '../shared/IS_Electron.service';
import { donwloadEleService } from '../bookShared/downloadELE.service';
interface Ipopupconfig {
  height: number,
  width: number,
  direction: string,
  arrowPos: number,
  showPopup: boolean,
  loadDirective: any,
  curComp: any
}


@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})



export class StoreComponent implements OnInit {
  Math: any;
  state = 'hide'
  public booksList;
  public categoryList;
  public currentBooksList;

  public scrollableDiv;
  public selectedBottomTabIndex = 0;
  public selectedGridIndex = 0;
  public isGridView = false;
  public showSubstoreDiv = false;
  public subStoreArray = [];
  public subBooksStore = [];
  public subBookStoresCopy = [];
  public currentSelectedBook;
  public headerBookUrl;
  public showLoader = false;
  public bookLoader = false;
  public selectebookIndex;
  public bookSubscription: any;
  public bookSubscription1: any;
  public downloadSubscription: any;
  public saveToBookPouchErrorSubscription: any;

  ActiveViewIndex = 0;
  selBookDetails;
  showSearchResults = false;
  searchItem = '';
  searchedContent = '';
  storeContentSearchWord = '';
  selectedBookTypeIndex = 0;
  toggleAppSearch = false;
  allDownloadedBooks;
  bookIcons = ['icon-Rename', 'icon-Share', 'icon-Imports', 'icon-Communication', 'icon-Chats'];
  options = ['Featured', 'Recently Added', 'Recently Accessed', 'Favourites'];
  @ViewChild('storeBooksContainer', { read: ElementRef }) public storeBooksContainer: ElementRef;
  @ViewChild('storeCategoriesContainer', { read: ElementRef }) public storeCategoriesContainer: ElementRef;

  public categories = [{ name: "Featured", icon: "icon-Featured" }, { name: "Categories", icon: "icon-Categories" }, { name: "Search", icon: "icon-Search-Flat" }, { name: "Update", icon: "icon-Update" }];
  public bookProps = [{ 'title': 'Author', 'ans': 'SemalebSS' }, { 'title': 'Language', 'ans': 'Arabic' }, { 'title': 'TotalPages', 'ans': '98' }];
  public bookTypes = [];
  public prevStoreList = [];
  public isStoresListView = true;
  public isSearchView = false;
  public isUpdateView = false;
  public searchArray: any = { 'Recent': [], 'Trending': ['test1', 'test2', 'test3', 'test4', 'test5'] };
  public searchCategoryList = ['Recent'];
  public hideTotalStores = true;
  public componentModels;
  totalSubStoresList;
  containerWidth = 20;
  counter = Array;
  booksListView = false;
  selTabIndex = 0;
  firstLevelFilterStores;


  // new store data
  bunchOfStores = [];
  storeContent;
  listOFCategories = [];
  storeCategoriesDic = [];
  isStoreCategoryView = false;
  categoryKeys = [];
  seletedStoreCategoriesGridInd = undefined;
  storesSections = [];
  storeCountriesData: any;
  filteredStoreCountries = [];
  filteredStoreLanguages = [];
  storeLanguagesList = [];
  totalLanguages = [];
  favouriteStores: any;
  recentlyAccessedStores: any = [];
  showStoreLoader = false;
  @HostListener('window:resize') onResize() {
    this.updateScrollNavbars();
  }
  @Input() data: any

  remoteDB;
  localDB;
  public storesListArray = [];
  popupParams: Ipopupconfig = {
    height: 400,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    loadDirective: '<app-tests></app-tests>',
    curComp: this,
  };
  globalPopupPara = <any>{};
  public gridToggleIcon = 'icon-BottomButton';
  constructor(public pouchservice: StorePouchDb, private http: Http, private shelfPouchDb: ShelfPouchDb, public dialog: MatDialog, private ele: ElementRef, private ElectronService: IS_ElectronService, private cdr: ChangeDetectorRef, private applicationRef: ApplicationRef, public dowloadEleservice: donwloadEleService) {

    this.Math = Math;
    PouchDB.plugin(PouchdbFind);

  }

  ngOnInit() {
    this.showStoreLoader = true;
    var person = ShelfValues.Purchases
    this.localDB = this.pouchservice.localDB;
    this.remoteDB = this.pouchservice.remoteDB;
    var self = this;

    // if (localStorage.userData != undefined && localStorage.userData != 'undefined') {
    this.pouchservice.isFavStortesAvailable().then(function (res) {
      self.favouriteStores = res;
      self.pouchservice.isRecentStoresAvailable().then(function (result) {
        self.recentlyAccessedStores = result;
        self.pouchservice.isRecentStoreSearchesAvailable().then(function (res: any) {
          self.searchArray['Recent'] = res.reverse();
          self.getPrivateStores();
        })

      })

    })
    // }
    // else {
    //   this.getPrivateStores();
    // }

    //Subscriber to maintain book dowloading percent
    this.downloadSubscription = this.ElectronService.downloadingPercent$.subscribe(message => {

      if (self.subBooksStore.length) {
        let obj = _.filter(self.subBooksStore, function (o) {
          return o.publishId == message.book.publishId;
        });

        if (obj[0]) {
          obj[0].isDownloading = true;
          obj[0].downloaded = false;
          obj[0].downloadingPercentage = message.percent;
        }

        if (!self.cdr['destroyed']) {
          self.cdr.detectChanges();
        }
      }

    });

    //Subscriber event after book downloaded completely
    this.bookSubscription1 = this.ElectronService.isBook$.subscribe(message => {

      if (self.subBooksStore.length) {
        let obj = _.filter(self.subBooksStore, function (o) {
          return o.publishId == message.publishId;
        });

        if (obj[0]) {
          obj[0].isDownloading = false;
          obj[0].downloaded = true;
          obj[0].downloadingPercentage = message.percent;
        }

        if (!self.cdr['destroyed']) {
          self.cdr.detectChanges();
        }
      }

    });

    //Subscriber event on save to book pouch error
    this.saveToBookPouchErrorSubscription = this.ElectronService.onBookPouchError$.subscribe(message => {

      console.log("came in to saveBookToPurchases error");
      console.log(message);

      let tempObj = _.filter(self.subBooksStore, function (o) {
        return o.publishId == message.publishId;
      });

      if (tempObj[0]) {
        tempObj[0].isDownloading = false;
        tempObj[0].downloaded = true;
      }

      if (!self.cdr['destroyed']) {
        self.cdr.detectChanges();
      }

    });

  }
  ngOnDestroy() {
    // if (this.bookSubscription) {
    //   this.bookSubscription.unsubscribe();
    // }

    // if (this.bookSubscription1)
    //   this.bookSubscription1.unsubscribe();

    // if (this.downloadSubscription)
    //   this.downloadSubscription.unsubscribe();

    this.cdr.detach();

  }



  getPrivateStores() {
    // getting entire store details here
    const headers = new Headers();
    if (localStorage.userToken != undefined && localStorage.userToken != 'undefined') {
      headers.append('Authorization', 'Bearer ' + localStorage.userToken);
    } else {
      headers.append('Authorization', '');
    }

    localStorage.storeHeaders = JSON.stringify(headers);

    const options = new RequestOptions({ headers: headers });
    var self = this;
    this.http.post(
      "http://" + Constants.nasUrl, {
        "query": 'query getStores{getStores{stores{storeId, parentStoreId, arabicStoreName, englishStoreName, lastModified, logo, description, isPrivateStore, price,count}storeDetails{storeId, storeDetailId, storeDetailGroupId,englishName, arabicName, orderSequence, classificationOneEnglishName,subClassificationOneEnglishName,classificationTwoEnglishName}storeDetailClassifications{parentClassificationId, storeDetailId, classificationId, englishName, arabicName, type, storeDetailGroupId}storeCategories{storeId, englishName, arabicName, categoryId}storeCountries{storeId, continent, countryEnglishName, countryArabicName, countryId}storeLanguages{storeId, language, languageId}} continents{id,name, countries{id, englishName, arabicName}}languages{id,name}}'
      }, options
    ).subscribe(
      res => {

        self.newStoreData(res.json().data)
      }
    );
  }

  newStoreData(data) {
    this.storeContent = data;
    this.bunchOfStores = data.getStores.stores;
    this.storesListArray = _.filter(this.bunchOfStores, function (filter) { return filter.parentStoreId == "" }) //storesListArray is firest level stores
    // document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
    this.showStoreLoader = false;
    this.listOFCategories = _.uniqBy(data.getStores.storeCategories, function (e: any) {
      return e.englishName;
    });

    this.listOFCategories = this.formstoreCategoriesDict(data.getStores.storeCategories);
    this.storeCountriesData = this.formStoreCountriesDict(data.getStores.storeCountries);
    this.storeLanguagesList = this.formStoreLanguagesList(data.getStores.storeLanguages);
    this.totalLanguages = data.languages;
    // this.categoryKeys = Object.keys(this.listOFCategories);
    this.categoryKeys = _.uniqBy(data.getStores.storeCategories, 'englishName');

    this.storesSections = this.formFirstLevelStoreCategories();
    this.containerWidth = 0;
    this.containerWidth = this.ele.nativeElement.querySelector('.mainStoreContainer').offsetWidth - 15;
  }

  formStoreCountriesDict(data) {
    var countriesData = [];
    data.forEach(template => {
      if (!countriesData['' + template.countryId + '']) {
        countriesData['' + template.countryId + ''] = [];
      }
      var obj = _.filter(this.bunchOfStores, function (filter) { return filter.storeId == template.storeId && filter.parentStoreId == '' })
      if (obj.length)
        countriesData['' + template.countryId + ''].push(obj[0])
    });
    return countriesData;
  }

  formStoreLanguagesList(data) {
    var languagesData = [];
    data.forEach(template => {
      if (!languagesData['' + template.languageId + '']) {
        languagesData['' + template.languageId + ''] = [];
      }
      var obj = _.filter(this.bunchOfStores, function (filter) { return filter.storeId == template.storeId && filter.parentStoreId == '' })
      if (obj.length)
        languagesData['' + template.languageId + ''].push(obj[0])
    });
    return languagesData;
  }


  formFirstLevelStoreCategories() {
    var dictionaryArray = [];
    var self = this;
    var favs = _.filter(this.bunchOfStores, function (filter) {
      var ind = _.findIndex(self.favouriteStores, function (o: any) { return o == filter.storeId; });
      if (ind != -1) {
        return filter
      }
    }
    )

    // var recents = _.filter(this.bunchOfStores, function (filter) {
    //   var ind = _.findIndex(self.recentlyAccessedStores, function (o: any) { return o == filter.storeId; });
    //   if (ind != -1) {
    //     return filter
    //   }
    // }
    // )

    var recents = [];
    for (var i = 0; i < this.recentlyAccessedStores.length; i++) {
      var ind = _.findIndex(this.bunchOfStores, function (o: any) { return o.storeId == self.recentlyAccessedStores[i]; });
      if (ind != -1) {
        recents.push(self.bunchOfStores[ind]);
      }
    }
    recents = recents.reverse();

    this.options.forEach(template => {
      if (template == 'Favourites') {
        dictionaryArray['' + template + ''] = favs;
      }
      else if (template == 'Recently Accessed') {
        dictionaryArray['' + template + ''] = recents;
      }
      else {
        dictionaryArray['' + template + ''] = this.storesListArray
      }
    });
    return dictionaryArray;
  }

  formstoreCategoriesDict(data) {
    data.forEach(template => {
      if (!this.storeCategoriesDic['' + template.englishName + '']) {
        this.storeCategoriesDic['' + template.englishName + ''] = [];
      }
      var obj = _.filter(this.bunchOfStores, function (filter) { return filter.storeId == template.storeId && filter.parentStoreId == '' })
      if (obj.length)
        this.storeCategoriesDic['' + template.englishName + ''].push(obj[0])
    });
    return this.storeCategoriesDic;
  }

  updateScrollNavbars() {
    this.containerWidth = this.ele.nativeElement.querySelector('.mainStoreContainer').offsetWidth - 15;
    var StoreCategoryLists = this.storeBooksContainer.nativeElement.querySelectorAll('.StoreCategoryLists');
    for (var i = 0; i < StoreCategoryLists.length; i++) {
      var scrollableCon = StoreCategoryLists[i].querySelector('.storeBooksContainer');
      let scrollNavigation = StoreCategoryLists[i].querySelectorAll('.booksNavigation');
      for (let j = 0; j < scrollNavigation.length; j++) {
        scrollNavigation[j].classList.remove('activeScrollBar')
      }
      if (scrollNavigation[0]) {
        scrollNavigation[0].classList.add('activeScrollBar')
      }
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = 0;
    }
    this.updateStoreCategoriesNavBars();
    var prevIconEles = this.ele.nativeElement.querySelectorAll('.animatePrev');
    for (var i = 0; i < prevIconEles.length; i++) {
      prevIconEles[i].classList.add('hidePrevNextIcons');
    }
  }

  ngAfterViewInit() {
    this.containerWidth = this.ele.nativeElement.querySelector('.mainStoreContainer').offsetWidth - 15;
  }

  goToShelf(ev) {
    this.data.appendComponentsToApp('shelf');
  }

  getSubStoreData(store, state) {
    var self = this;
    //  getting sub stores by comparing with storeId
    this.isStoreCategoryView = false;
    this.isStoresListView = true;
    var temp = {
      englishStoreName: state
    }
    this.prevStoreList.push(temp);
    this.currentSelectedBook = store;
    this.showSubstoreDiv = true;
    this.subStoreArray = _.filter(this.bunchOfStores, function (filter) { return filter.parentStoreId == store.storeId });

    // if(localStorage.userData != undefined && localStorage.userData != 'undefined'){
    //   this.pouchservice.addStoreIntoRecents(store).then(function(data){
    //     self.addRecentStoreList(data);
    //   })
    // }


    if (!this.subStoreArray.length) {
      this.isSubStoreAvailable(store, 'parent');
    }

    // subStoreArray is sub level stores
  }

  isSubStoreAvailable(store, from) {
    var self = this;
    // checking for sub level stores is available for current store or not
    this.subStoreArray = _.filter(this.bunchOfStores, function (filter) { return filter.parentStoreId == store.storeId });
    if (!this.subStoreArray.length) {
      // if it is last store
      this.bookTypes = this.storeContent.getStores.storeDetails;
      this.selTabIndex = 0;
      if (this.bookTypes.length && localStorage.userData != undefined && localStorage.userData != 'undefined') {
        this.pouchservice.addStoreIntoRecents(store).then(function (data) {
          self.addRecentStoreList(data);
        })
      }

      this.bookTypes = _.filter(this.bookTypes, function (filter) { return filter.storeId == store.storeId });
      // bookTypes is storeclassifications

      this.selectedBookTypeIndex = 0;
      if (self.bookTypes[0]) {

        this.gettingStoreContentData(store, 0)
      }

    }
    if (from != 'parent') {
      this.prevStoreList.push(this.currentSelectedBook);
    }
    this.currentSelectedBook = store
  }

  appendDownloadingPropertyToBooks(subBooksStore) {
    subBooksStore.forEach(function (obj) {
      if (!obj.downloadingPercentage) {
        obj.downloadingPercentage = 0;
        obj.isDownloading = false;
        obj.downloaded = false;
      }
    });
  }

  gettingStoreContentData(store,ind){
    var self = this;
this.showLoader = true;
let headers = JSON.parse(localStorage.storeHeaders);
const options = new RequestOptions({ headers: headers });

    this.http.post(
      "http://" + Constants.nasUrl, {
        "query": 'query publishedContent{getPubLishedContent(storeDetailId:' + JSON.stringify(self.bookTypes[ind].storeDetailId) + '){storeContent{languageId,storeDetailGroupId,publishId,description,title,author,type,zipUrl,storeDetailId,thumbnailUrl,classificationIds,previewUrl,ISBIN,price,pageCount, updatedAt,isDefaultFeature,featureCodes}}}'
      }, options
    ).subscribe(
      res => {
        self.updateStoreContentData(res.json().data);
      }

    );

  }

  updateStoreContentData(data) {

    // this.subBooksStore = _.filter(this.storeContent.privateAppStores.storeContent, function (filter) { return (filter.storeDetailGroupId == self.bookTypes[0].storeDetailGroupId && filter.storeDetailId == self.bookTypes[0].storeDetailId ) });

    this.subBooksStore = data.getPubLishedContent.storeContent
    this.subBooksStore = _.uniqBy(this.subBooksStore, 'publishId');

    this.appendDownloadingPropertyToBooks(this.subBooksStore);
    this.subBookStoresCopy = JSON.parse(JSON.stringify(this.subBooksStore));
    // subBooksStore is storeContent

    this.updateFilterFirstLevel(0)

    // firstLevelFilterStores is for classifications filter

    var temp = JSON.parse(localStorage.purchasesList);

    // checking that store books are downloaded or not
    this.pouchservice.getBookData(this, temp);
  }


  isItsLastSubStore(store) {
    var temp = _.filter(this.bunchOfStores, function (filter) { return filter.parentStoreId == store.storeId });
    if (temp.length) {
      return true;
    } else {
      return false;
    }
  }


  // showBooksList(ind, obj) {
  //   this.selTabIndex = ind;

  //   this.subBooksStore = _.filter(this.storeContent.privateAppStores.storeContent, function (filter) { return filter.storeDetailGroupId == obj.storeDetailGroupId && filter.storeDetailId == obj.storeDetailId });

  //   this.subBooksStore = _.uniqBy(this.subBooksStore, 'publishId');
  //   this.subBookStoresCopy = JSON.parse(JSON.stringify(this.subBooksStore));

  //    this.appendDownloadingPropertyToBooks(this.subBooksStore);
  //   var temp = JSON.parse(localStorage.purchasesList);
  //   this.pouchservice.getBookData(this, temp);

  // }


  downloadedBooks(data) {
    console.log("In downloadedBooks");
    this.allDownloadedBooks = data;
    this.applyDownloadedOptionForBooks();
  }

  applyDownloadedOptionForBooks(){
    for (let i = 0; i < this.subBooksStore.length; i++) {
      let temp = Constants.USER + "." + this.subBooksStore[i].publishId + ".book";
      var ind = _.indexOf(_.map(this.allDownloadedBooks, '_id'), temp);
      if (ind > -1) {
        //In case of handling downloading books and their percent
        if (this.ElectronService.downloadingBooksArray.length) {
          this.updateDownloadingBooksStatus();
        }
        else {
          this.subBooksStore[i].downloaded = true;
        }
      }
    }

    this.showLoader = false;
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  updateDownloadingBooksStatus() {
    for (let i = 0; i < this.subBooksStore.length; i++) {

      let index = -1;
      for (let k = 0; k < this.ElectronService.downloadingBooksArray.length; k++) {
        if (this.ElectronService.downloadingBooksArray[k]['publishId'] == this.subBooksStore[i].publishId) {
          index = i;
          if (index != -1) {
            this.subBooksStore[i].isDownloading = true;
          }
          else {
            this.subBooksStore[i].downloaded = true;
          }
        }
      }

    }

  }

  navigateContainer(name, index) {
    this.toggleAppSearch = false;
    this.subStoreArray = [];
    this.showSubstoreDiv = false;
    this.prevStoreList = [];
    this.subBooksStore = [];
    this.bookTypes = [];
    this.subBookStoresCopy = JSON.parse(JSON.stringify(this.subBooksStore));

    if (name == 'Search') {
      this.isStoresListView = false;
      this.isSearchView = true;
      this.isUpdateView = false;
      this.isStoreCategoryView = false;
    }
    else if (name == 'Update') {
      this.isStoresListView = false;
      this.isSearchView = false;
      this.isUpdateView = true;
      this.isStoreCategoryView = false;
    }
    else if (name == 'Categories') {
      this.isStoreCategoryView = true;
      this.isStoresListView = false;
      this.isSearchView = false;
      this.isUpdateView = false;
    }
    else {
      this.isStoresListView = true;
      this.isSearchView = false;
      this.isUpdateView = false;
      this.isStoreCategoryView = false;
    }

    if ((name != 'Search' || name != 'Update')) {
      // this.categoryList = Object.keys(this.booksList[name][0]);
      // this.currentBooksList = this.booksList[name][0];
    }
    this.selectedBottomTabIndex = index;
  }

  mouseEnter(evt, index) {

    // if (evt.currentTarget.querySelector('.storeBooksContainer').scrollWidth > evt.currentTarget.querySelector('.storeBooksContainer').offsetWidth) {

    this.scrollableDiv = evt.currentTarget.querySelector('.storeBooksContainer');
    // }

  }
  mouseLeave(evt, index) {
    this.scrollableDiv = undefined;
  }

  onPrevious(ind) {


    var StoreCategoryLists = this.storeBooksContainer.nativeElement.querySelectorAll('.StoreCategoryLists')[ind];
    var scrollableCon = StoreCategoryLists.querySelector('.storeBooksContainer');

    let scrollNavigation = StoreCategoryLists.querySelectorAll('.booksNavigation');
    let activeIndex;
    for (let i = 0; i < scrollNavigation.length; i++) {
      if (scrollNavigation[i].classList.contains('activeScrollBar')) {
        activeIndex = i;
      }
    }

    if (scrollNavigation[activeIndex - 1]) {
      let dis = scrollableCon.scrollLeft;
      let temp = scrollableCon.scrollLeft - this.containerWidth;
      scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = temp;


      if (activeIndex - 1 == 0) {
        StoreCategoryLists.querySelector('.animatePrev').classList.add('hidePrevNextIcons');
      }
    }

    // let dis = this.storeBooksContainer.nativeElement.scrollLeft;
    // let temp = this.storeBooksContainer.nativeElement.scrollLeft - this.containerWidth;
    // this.storeBooksContainer.nativeElement.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // this.ActiveViewIndex = this.ActiveViewIndex - 1;
    // var interval = setInterval(() => {
    //   this.scrollableDiv.scrollLeft = dis;
    //   dis = dis - 50;
    //   if (dis < temp) {
    //     clearInterval(interval);
    //   }
    // }, 25);
  }

  onNext(ind) {


    var StoreCategoryLists = this.storeBooksContainer.nativeElement.querySelectorAll('.StoreCategoryLists')[ind];
    var scrollableCon = StoreCategoryLists.querySelector('.storeBooksContainer');

    let scrollNavigation = StoreCategoryLists.querySelectorAll('.booksNavigation');
    let activeIndex;
    for (let i = 0; i < scrollNavigation.length; i++) {
      if (scrollNavigation[i].classList.contains('activeScrollBar')) {
        activeIndex = i;
      }
    }

    if (scrollNavigation[activeIndex + 1]) {
      let dis = scrollableCon.scrollLeft;
      let temp = scrollableCon.scrollLeft + this.containerWidth;
      scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = temp;
      StoreCategoryLists.querySelector('.animatePrev').classList.remove('hidePrevNextIcons');
    } else {

      scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      scrollNavigation[0].classList.add('activeScrollBar');
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = 0;
      StoreCategoryLists.querySelector('.animatePrev').classList.add('hidePrevNextIcons');
    }

  }

  showGridView(index) {

    if (this.isGridView) {
      this.isGridView = false;
      this.selectedGridIndex = 0;
      this.gridToggleIcon = 'icon-BottomButton';
    } else {
      this.isGridView = true;
      this.selectedGridIndex = index;
      this.gridToggleIcon = 'icon-TopButton';
    }
  }

  onSelectChange(evt) {
    var self = this;
    var clickedStoreDetail = [];
    this.subStoreArray = [];
    this.updateFilterFirstLevel(evt.index)
    this.selectedBookTypeIndex = evt.index;
    // this.showBooksList(evt.index, this.bookTypes[evt.index])
    this.gettingStoreContentData(this.currentSelectedBook, evt.index)

  }

  gotoPreviousStore(name, index) {
    this.toggleAppSearch = false;
    this.subBooksStore = [];
    this.subBookStoresCopy = JSON.parse(JSON.stringify(this.subBooksStore));
    this.bookTypes = [];
    if (index == 0) {
      this.subStoreArray = [];
      this.showSubstoreDiv = false;
      this.prevStoreList = [];
      if (this.selectedBottomTabIndex == 1) {
        this.navigateContainer('Categories', 1);
      }

      if (this.selectedBottomTabIndex == 2) {
        this.navigateContainer('Search', 2);

      }

    } else {
      this.currentSelectedBook = this.prevStoreList[index];
      // this.subStoreArray = this.prevStoreList[index - 1];
      this.isSubStoreAvailable(this.prevStoreList[index], 'prev');
      for (let i = 0; i <= (this.prevStoreList.length - (index - 1)); i++) {
        this.prevStoreList.pop();
      }
    }
  }

  showFilterOptions(popupParams: Ipopupconfig, ev, width, height): void {

    popupParams.loadDirective = StoreFilterComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 100;
    popupParams.direction = "right";
  }
  saveBookToPurchases(book, state) {

    var self = this;
    if (state == true) {
      this.openPurchasesBook(book);
      return;
    }

    this.bookLoader = true;
    book.isDownloading = true;

    if (this.ElectronService.IS_ELECTRON) {

      // this.ElectronService.storeBookDownload(book);

      // this.bookSubscription = this.ElectronService.isBook$.subscribe(message => {

      //   if (self.currentDownloadingBook == undefined || self.currentDownloadingBook.publishId != message.publishId) {
      //     //for test purpose
      //     self.currentDownloadingBook = message;
      //     //
      //     self.pouchservice.saveBookToPurchases(message).then(function (data) {
      //       console.log("came in to saveBookToPurchases hten section");
      //       let bookObj = data['bookObj'];
      //       let bookDataObj = data['bookDataObj'];
      //       if (book.type == 'LIQUID')
      //         self.dowloadEleservice.createPurchasedNewElessonBook(bookObj, bookDataObj);

      //     });
      //   }

      // });


      //Test purpose

      // this.pouchservice.saveBookToPurchases(book).then((data) => {

      //   console.log("came in to saveBookToPurchases then");

      //   self.ElectronService.storeBookDownload(book);


      //   self.bookSubscription = self.ElectronService.isBook$.subscribe(message => {

      //     let bookObj = data['bookObj'];
      //     let bookDataObj = data['bookDataObj'];
      //     if ((message.type == 'LIQUID' || message.type == "OLDELE") && message.publishId == bookObj.bId)
      //       self.dowloadEleservice.createPurchasedNewElessonBook(bookObj, bookDataObj);


      //   });
      // },
      //   (err) => {
      //     console.log("came in to saveBookToPurchases error");
      //     console.log(err);

      //     let tempObj = _.filter(self.subBooksStore, function (o) {
      //       return o.publishId == err.publishId;
      //     });

      //     tempObj[0].isDownloading = false;
      //     tempObj[0].downloaded = true;

      //     if (!self.cdr['destroyed']) {
      //       self.cdr.detectChanges();
      //     }

      //   });
      //

      self.ElectronService.storeBookDownload(book, this.pouchservice, this.dowloadEleservice);

    }
    else {

      this.pouchservice.saveBookToPurchases(book).then(function (data) {
        book.downloaded = true;
        book.isDownloading = false;
        self.bookLoader = false;
      });

    }

  }




  selectCountry(popupParams, ev, width, height, state, arrposition): void {
    ev.stopPropagation();
    let widthVal = '900px';
    var information = {
      continents: this.storeContent.continents,
      prevSelectedCountries: this.filteredStoreCountries,
      languages: this.totalLanguages,
      prevSelectedLanguages: this.filteredStoreLanguages
    }

    let dialogRef = this.dialog.open(selectCountryAndLanguage, {
      width: widthVal,
      data: information,
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && (result.countries.length || result.languages.length)) {

        this.updateFilteredCountries(result, result.countries);

      } else {
        this.storesListArray = _.filter(this.bunchOfStores, function (filter) { return filter.parentStoreId == "" });
        this.storesSections = this.formFirstLevelStoreCategories();
      }
    });

  }
  updateFilteredCountries(result, data) {
    console.log(this.storeCountriesData)

    if (data.length) {
      var countries = data.map(o => o.id);
      this.filteredStoreCountries = data;

      this.storesListArray = [];
      for (var i = 0; i < countries.length; i++) {
        if (!this.storesListArray && !this.storesListArray.length) {
          this.storesListArray = this.storeCountriesData[countries[i]];
        } else {
          if (this.storeCountriesData[countries[i]])
            this.storesListArray = _.concat(this.storesListArray, this.storeCountriesData[countries[i]]);
        }
      }
    } else {
      this.storesListArray = _.filter(this.bunchOfStores, function (filter) { return filter.parentStoreId == "" });
    }
    if (result.languages.length) {
      this.updateSelectedLanguagesStores(result.languages)
    }

    this.storesSections = this.formFirstLevelStoreCategories();
    this.storesListArray = _.uniq(this.storesListArray);
  }


  updateSelectedLanguagesStores(data) {
    var self = this;
    this.filteredStoreLanguages = data;

    var languageStores = [];
    for (var i = 0; i < data.length; i++) {

      if (this.storeLanguagesList[data[i].id]) {
        if (!languageStores.length) {
          languageStores = this.storeLanguagesList[data[i].id];
        } else {
          languageStores = _.concat(languageStores, this.storeLanguagesList[data[i].id])
        }
        languageStores = _.uniq(languageStores);
      }
    }

    if (this.storesListArray.length > languageStores.length) {
      this.storesListArray = this.storesListArray.filter(function (n) {
        return languageStores.indexOf(n) !== -1;
      });
    }
    else {
      this.storesListArray = languageStores.filter(function (n) {
        return self.storesListArray.indexOf(n) !== -1;
      });
    }

  }

  openPurchasesBook(book) {
    var id = Constants.USER + "." + book.publishId + ".book";
    this.pouchservice.getBookObject(id, this);
  }

  openBookObject(book) {
    var self = this;
    this.data.bookObj = book;
    this.shelfPouchDb.addBooksIntoRecents(book);
    this.shelfPouchDb.getbookDataObj(book).then(function (result) {
      self.data.bookDataObj = result;

      if (book.bookType == 8) {
        self.data.appendComponentsToApp('ALB');
      }
      else if (book.bookType == 3) {
        self.data.appendComponentsToApp('ELE');
      }
      else {
        self.data.appendComponentsToApp('EBE');
      }
    })

  }

  displayStoreBookDetails(popupParams, ev, width, height, book, ind) {
    this.selBookDetails = book;
    this.storeBookDetailsDialog(book, ind);

  }

  storeBookDetailsDialog(book, ind) {
let self = this;
    let widthVal = '300px';
    book.ind = ind;
    let dialogRef = this.dialog.open(storeBookDialog, {
      width: widthVal,
      data: book,
      disableClose: false,

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        self.saveBookToPurchases(result,result.downloaded);
      }
    });
  }

  addBookThumbnail(data) {

    var res = data.split(",");
    if (res[0] && res.length > 1) {
      return res[0];
    } else {
      return 'http://hyd.semanooor.com/NooorM/Pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/cover.png';
    }
  }

  updateFilterFirstLevel(ind) {
    this.firstLevelFilterStores = [];

    if (this.bookTypes[ind]) {
      this.firstLevelFilterStores.push({ id: 'CLASSIFICATION_ONE', englishName: this.bookTypes[ind].classificationOneEnglishName, prefix: { name: 'All', id: '' } });
      this.firstLevelFilterStores.push({ id: 'SUB_CLASSIFICATION_ONE', englishName: this.bookTypes[ind].subClassificationOneEnglishName, prefix: { name: 'All', id: '' } });
      this.firstLevelFilterStores.push({ id: 'CLASSIFICATION_TWO', englishName: this.bookTypes[ind].classificationTwoEnglishName, prefix: { name: 'All', id: '' } });
      this.firstLevelFilterStores.push({ id: 'PRICE', englishName: 'PRICE', prefix: { name: 'All', id: '' } });
      this.firstLevelFilterStores.push({ id: 'TYPE', englishName: 'TYPE', prefix: { name: 'All', id: '' } });
      this.firstLevelFilterStores.push({ id: 'AUTHOR', englishName: 'AUTHOR', prefix: { name: 'All', id: '' } });
    }

  }

  makeStoreFav(store) {
    var self = this;
    // if (localStorage.userData != undefined && localStorage.userData != 'undefined') {
    this.pouchservice.favouriteStoreIds(store).then(function (res) {
      self.favouriteStores = res;
      self.storesSections['Favourites'] = _.filter(self.bunchOfStores, function (filter) {
        var ind = _.findIndex(self.favouriteStores, function (o: any) { return o == filter.storeId; });
        if (ind != -1) {
          return filter
        }
      })
    })
    // }
  }


  addRecentStoreList(res) {
    var self = this;
    self.recentlyAccessedStores = res;
    var recents = [];
    for (var i = 0; i < this.recentlyAccessedStores.length; i++) {
      var ind = _.findIndex(this.bunchOfStores, function (o: any) { return o.storeId == self.recentlyAccessedStores[i]; });
      if (ind != -1) {
        recents.push(self.bunchOfStores[ind]);
      }
    }
    self.storesSections['Recently Accessed'] = recents.reverse();
  }


  isStoreFav(store) {
    let index = _.findIndex(this.favouriteStores, function (o: any) { return o == store.storeId; });
    if (index != -1) {
      return true;
    } else {
      return false;
    }
  }

  onStoreCategoriesNext(ind) {

    var scrollableCon = this.ele.nativeElement.querySelectorAll('.storeCategoriesBooksCon')[ind];
    let scrollNavigation = scrollableCon.parentElement.querySelectorAll('.booksNavigation');
    let activeIndex;
    for (let i = 0; i < scrollNavigation.length; i++) {
      if (scrollNavigation[i].classList.contains('activeScrollBar')) {
        activeIndex = i;
      }
    }


    if (scrollNavigation[activeIndex + 1]) {

      scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');
      var temp = scrollableCon.scrollLeft + this.containerWidth;
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = temp;
      scrollableCon.parentElement.querySelector('.animatePrev').classList.remove('hidePrevNextIcons');
    } else {
      scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      scrollNavigation[0].classList.add('activeScrollBar');
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = 0
      scrollableCon.parentElement.querySelector('.animatePrev').classList.add('hidePrevNextIcons');
    }

  }

  updateStoreCategoriesNavBars() {

    this.containerWidth = this.ele.nativeElement.querySelector('.mainStoreContainer').offsetWidth - 15;
    var StoreCategoryLists = this.ele.nativeElement.querySelectorAll('.storeCategoriesBooksCon');
    for (var i = 0; i < StoreCategoryLists.length; i++) {
      var scrollableCon = StoreCategoryLists[i];
      let scrollNavigation = StoreCategoryLists[i].parentElement.querySelectorAll('.booksNavigation');
      for (let j = 0; j < scrollNavigation.length; j++) {
        scrollNavigation[j].classList.remove('activeScrollBar')
      }
      if (scrollNavigation[0]) {
        scrollNavigation[0].classList.add('activeScrollBar')
      }
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = 0;
    }



  }

  onStoreCategoriesPrevious(ind) {

    var scrollableCon = this.ele.nativeElement.querySelectorAll('.storeCategoriesBooksCon')[ind];
    let scrollNavigation = scrollableCon.parentElement.querySelectorAll('.booksNavigation');
    let activeIndex;
    for (let i = 0; i < scrollNavigation.length; i++) {
      if (scrollNavigation[i].classList.contains('activeScrollBar')) {
        activeIndex = i;
      }
    }


    if (scrollNavigation[activeIndex - 1]) {
      let dis = scrollableCon.scrollLeft;
      var temp = scrollableCon.scrollLeft - this.containerWidth;
      if (!this.ElectronService.IS_ELECTRON)
        scrollableCon.scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      else
        scrollableCon.scrollLeft = temp;
      scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');


      if (activeIndex - 1 == 0) {
        scrollableCon.parentElement.querySelector('.animatePrev').classList.add('hidePrevNextIcons');
      }
    }
  }

  displayCategoriesInGridView(ind) {
    if (ind != this.seletedStoreCategoriesGridInd) {
      this.seletedStoreCategoriesGridInd = ind;
    } else {
      this.seletedStoreCategoriesGridInd = undefined;
    }
  }

  storeSearchOnEnter(ev, text) {
    let self = this;
    if (ev.which == 13) {
      this.pouchservice.addSearchedItemIntoRecentSearches(text).then(function (res: any) {
        self.searchArray['Recent'] = res.reverse();
      })
      this.showSearchResults = true;
      this.searchedContent = text;
    }
  }

  closeStoreSearchs(ev) {
    if (ev == 'close') {
      this.showSearchResults = false;
      return
    } else if (ev.state == 'Stores' || ev.state == 'Sub Stores') {
      //  this.selectedBottomTabIndex = 0;
      //  this.navigateContainer('Featured', 0)
      this.isStoresListView = true;
      this.isSearchView = false;
      this.isUpdateView = false;
      this.isStoreCategoryView = false;
      this.getSubStoreData(ev.obj, ev.state);

    } else if (ev.state == 'BookDetails') {
      this.displayStoreBookDetails(this.popupParams, ev.ev, '250', '350', ev.obj,0);
    } else if (ev.state == 'downloadBook') {
      this.saveBookToPurchases(ev.obj, ev.isDownloaded);
    }
  }

  quickSearch(text){
    let self = this;
    this.searchItem = text;
    this.pouchservice.addSearchedItemIntoRecentSearches(text).then(function(res:any){
      self.searchArray['Recent'] = res.reverse();
    })
    this.showSearchResults = true;
    this.searchedContent = text;
  }

  showFilteredStoreContent(ev,name){
    var self = this;
    // this.subBooksStore = _.filter(this.storeContent.privateAppStores.storeContent, function (filter) { return (filter.storeDetailGroupId == self.bookTypes[self.selectedBookTypeIndex].storeDetailGroupId && filter.storeDetailId == self.bookTypes[self.selectedBookTypeIndex].storeDetailId ) });
    this.subBooksStore = JSON.parse(JSON.stringify(this.subBookStoresCopy));
    this.subBooksStore = _.uniqBy(this.subBooksStore, 'publishId');
    name = name.trim();
    name = name.toLowerCase();
    if(name != ''){
      this.subBooksStore = _.filter(this.subBooksStore, function (filter) { return filter.title.toLowerCase().includes(name) || filter.author.toLowerCase().includes(name) })
      this.subBooksStore = _.uniqBy(this.subBooksStore, 'publishId');
    }
    this.applyDownloadedOptionForBooks();
  }

  assigningStoreName(store){
    store.selLanguageName  = '';
    if(localStorage.selectedLanguageInd == 1){
      store.selLanguageName = store.arabicStoreName
    }else{
      store.selLanguageName = store.englishStoreName
    }
    return true;
  }

  assigningCategoryName(category){
    category.selLanguageName  = '';
    if(localStorage.selectedLanguageInd == 1){
      category.selLanguageName = category.arabicName
    }else{
      category.selLanguageName = category.englishName
    }
    return true;
  }

  updateDate(book,date){
    var d = new Date(date);
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    book.month = months[d.getMonth()];
    book.year = d.getFullYear();
    book.day = d.getDay();
    return false;
  }

}

// store info popup

@Component({
  selector: 'app-storeBookDialog',
  templateUrl: './popups/storeBookDetails/storeBookDetails.component.html',
  styleUrls: ['./popups/storeBookDetails/storeBookDetails.component.css','./store.component.css']
})
export class storeBookDialog {
  bookFooterIcon = ["icon-Rename", "icon-Share", "icon-Imports", "icon-Communication", "icon-Annotation"];
  bookDetails;
  bookCategoeyEnums = bookCategoeyEnums;
  bookCategoryTypes = bookCategories;
  type;
  constructor(
    public dialogRef: MatDialogRef<storeBookDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, private ElectronService: IS_ElectronService) {
    this.bookDetails = data;
    if (this.bookDetails.type == 'PDF') {
      this.bookDetails.altBookType = this.bookCategoeyEnums.pdf;   
  } else {
    this.bookDetails.altBookType = this.bookCategoeyEnums.NewElesson;
  }

  this.type = this.bookCategoryTypes[bookCategoeyEnums[this.bookDetails.altBookType]]
  }

  ngOnDestroy(){
    Object.keys(this).map(k => {
      this[k] = null;
      })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick() {
    this.dialogRef.close();
  }

  downloadCurrentBook(){
    this.dialogRef.close(this.bookDetails);
  }
  openCurrentBook(){
    this.dialogRef.close(this.bookDetails);
  }

}

// select country and language popup


@Component({
  selector: 'app-selectCountryAndLanguage',
  templateUrl: './popups/countrydetails/selectCountryAndLanguage.html',
  styleUrls: ['./popups/countrydetails/countrydetails.component.css']
})
export class selectCountryAndLanguage {
  continents;
  continentIndex = 0;
  selectedCountriesList = [];
  selectedLanguagesList = [];
  languagesList = [];
  allCountriesList = [];
  constructor(
    public dialogRef: MatDialogRef<selectCountryAndLanguage>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.continents = JSON.parse(JSON.stringify(data.continents));
    let allContinentsList = JSON.parse(JSON.stringify(data.continents))
   this.allCountriesList = [];
    for(var i = 0; i< allContinentsList.length;i++){
      for(var j = 0; j<allContinentsList[i].countries.length;j++){
        this.allCountriesList.push(allContinentsList[i].countries[j]);
      }
    }

    let all = {
      name:'All',
      countries :JSON.parse(JSON.stringify(this.allCountriesList))
    }
    this.continents.splice(0, 0, all);
    this.selectedCountriesList = data.prevSelectedCountries;
    this.languagesList = data.languages;
    this.selectedLanguagesList = data.prevSelectedLanguages;

    if(this.selectedCountriesList.length == 0){
      this.selectedCountriesList = this.allCountriesList
    }
    if(this.selectedLanguagesList.length == 0){
      this.selectedLanguagesList = JSON.parse(JSON.stringify(this.languagesList));
    }
  }

  onNoClick(): void {

    var object = {
      countries: this.selectedCountriesList,
      languages: this.selectedLanguagesList
    }
    this.dialogRef.close(object);
  }

  onYesClick() {
    var object = {
      countries: this.selectedCountriesList,
      languages: this.selectedLanguagesList
    }
    this.dialogRef.close(object);
  }

  changeContinent(ev) {
    this.continentIndex = ev.index;
    if(this.continentIndex == 0 && this.selectedCountriesList.length == 0){
      this.selectedCountriesList = this.allCountriesList;
    }
  }

  onselectedCountryChange(ev, country) {
    var ind = _.findIndex(this.selectedCountriesList, function (o) { return o.id == country.id });
    if (ind == -1) {
      this.selectedCountriesList.push(country);
    } else {
      this.selectedCountriesList.splice(ind, 1);
    }
  }

  onselectedLanguageChange(ev, language) {
    var ind = _.findIndex(this.selectedLanguagesList, function (o) { return o.id == language.id });
    if (ind == -1) {
      this.selectedLanguagesList.push(language);
    } else {
      this.selectedLanguagesList.splice(ind, 1);
    }
  }

  updateIsCountryIsChecked(country) {

    // if(this.selectedCountriesList.length == 0 && this.continentIndex == 0){
    //   return true;
    // }

    var ind = _.findIndex(this.selectedCountriesList, function (o) { return o.id == country.id });
    if (ind != -1) {
      return true;
    } else {
      return false;
    }
  }

  updateIsLanguageIsChecked(language) {

    if(language == 'All'){
      if(this.languagesList.length == this.selectedLanguagesList.length){
        this.selectedLanguagesList = JSON.parse(JSON.stringify(this.languagesList));
        return true;
      }else{
        return false;
      }
    }else{
      var ind = _.findIndex(this.selectedLanguagesList, function (o) { return o.id == language.id });
      if (ind != -1) {
        return true;
      } else {
        return false;
      }
    }

  
  }

  assigningCountryName(country){
    country.selLanguageName  = '';
    if(localStorage.selectedLanguageInd == 1){
      country.selLanguageName = country.arabicName
    }else{
      country.selLanguageName = country.englishName
    }
    return true;
  }
}





// WEBPACK FOOTER //
// ./src/app/store/store.component.ts